import { computed } from 'vue'
import { createSharedComposable } from '@vueuse/core'
import { useBreadcrumb_experimental } from '@/vue/components/navigation/BreadcrumbNav/use-breadcrumbs'

export const useAssetOnlyAccess = createSharedComposable(() => {
    const { company, portfolio } = useBreadcrumb_experimental()
    const assetOnlyAccess = computed(() => {
        return portfolio.value?.asset_only_access ?? company.value?.asset_only_access ?? false
    })
    return assetOnlyAccess
})
